module.exports = __webpack_public_path__ + "fonts/montserrat-italic-webfont.3d332ba.woff";